import { faChartLine, faMoneyBill } from "@fortawesome/free-solid-svg-icons";

// StatPills.jsx
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatInReal } from "../../../../commons/util/HallAppUtil";

function StatPill({ icon, label, value }) {
  return (
    <div className="hc-cd-pill">
      <div className="hc-cd-pill__label">
        <FontAwesomeIcon icon={icon} className="me-2" />
        {label}
      </div>
      <div className="hc-cd-pill__value">{value}</div>
    </div>
  );
}

export default function StatPills({ stats }) {
  return (
    <div className="hc-cd-pills">
      <StatPill icon={faMoneyBill} label="Total gasto" value={formatInReal(stats.totalSpent)} />
      <StatPill icon={faChartLine} label="Visitas/mês" value={stats.avgPerMonth} />
      <StatPill icon={faMoneyBill} label="Ticket médio" value={formatInReal(stats.avgTicket)} />
    </div>
  );
}
